import React, { useState } from 'react';
import Page from '../components/Page';
import { useActiveShift, openShift, closeShift } from '../controllers/financial.controller';

export default function FinancialShiftPage() {
  const { shift, isLoading, mutate } = useActiveShift();
  const [openingCash, setOpeningCash] = useState('');
  
  const handleOpen = async () => {
    if(!openingCash) return alert("Enter opening cash");
    await openShift(parseFloat(openingCash), []);
    mutate();
  };

  const handleClose = async () => {
    if(!window.confirm("Close this shift?")) return;
    await closeShift(shift.id, 0, [], 0, 0); // TODO: actual logic for drawer difference
    mutate();
  };

  if(isLoading) return <Page><div className="p-3">Loading...</div></Page>;

  return (
    <Page>
      <div className="container-xl">
        <div className="page-header d-print-none text-white">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Shift Control</h2>
            </div>
          </div>
        </div>

        <div className="page-body">
          {!shift ? (
            <div className="card text-center py-5">
              <div className="card-body">
                <h2>No Active Shift</h2>
                <p className="text-muted">You must open a physical shift drawer before taking transactions.</p>
                <div className="mx-auto" style={{maxWidth: '300px'}}>
                  <div className="mb-3">
                    <label className="form-label text-start">Opening Drawer Cash</label>
                    <input type="number" className="form-control" value={openingCash} onChange={e=>setOpeningCash(e.target.value)} placeholder="0.00" />
                  </div>
                  <button className="btn btn-primary w-100" onClick={handleOpen}>Open Shift</button>
                </div>
              </div>
            </div>
          ) : (
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-start mb-4">
                  <div>
                    <h3 className="text-green mb-1">● ACTIVE SHIFT</h3>
                    <div className="text-muted">Opened: {new Date(shift.opened_at).toLocaleString()}</div>
                    <div className="text-muted">Cashier: {shift.cashier_name}</div>
                  </div>
                  <div>
                    <button className="btn btn-danger" onClick={handleClose}>Close Shift</button>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <h4 className="border-bottom pb-2">Drawer Cash Flow</h4>
                    <table className="table table-sm table-borderless">
                      <tbody>
                        <tr><td>Opening Cash</td><td className="text-end fw-bold">NPR {shift.opening_cash}</td></tr>
                        <tr><td>Cash Sales</td><td className="text-end">NPR 0.00</td></tr>
                        <tr><td>Cash Expenses</td><td className="text-end text-danger">-NPR 0.00</td></tr>
                        <tr className="border-top"><td className="fw-bold text-primary">Expected Drawer Cash</td><td className="text-end fw-bold text-primary">NPR {shift.opening_cash}</td></tr>
                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
            </div>
          )}
        </div>
      </div>
    </Page>
  );
}
